'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUrlRoot = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var getUrlRoot = exports.getUrlRoot = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(modulePath, options) {
        var cached, currentEnv, response, responseBody, contentRoot;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        cached = window.FrontendVersionUtil && window.FrontendVersionUtil.contentRoots && window.FrontendVersionUtil.contentRoots[modulePath];

                        if (!cached) {
                            _context.next = 4;
                            break;
                        }

                        return _context.abrupt('return', cached);

                    case 4:
                        _context.next = 6;
                        return (0, _uigCdnLibraries.polyfillFetch)();

                    case 6:
                        currentEnv = options && options.currentEnv || (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();
                        _context.next = 9;
                        return fetch(moduleCurrentVersionUrl(modulePath, currentEnv, options));

                    case 9:
                        response = _context.sent;
                        _context.next = 12;
                        return response.json();

                    case 12:
                        responseBody = _context.sent;
                        contentRoot = responseBody.rootUrl || responseBody.cdnRootUrl;

                        if (contentRoot) {
                            _context.next = 16;
                            break;
                        }

                        throw new Error('missing .rootUrl from response');

                    case 16:

                        window.FrontendVersionUtil = window.FrontendVersionUtil || {};
                        window.FrontendVersionUtil.contentRoots = window.FrontendVersionUtil.contentRoots || {};
                        window.FrontendVersionUtil.contentRoots[modulePath] = contentRoot;

                        return _context.abrupt('return', contentRoot);

                    case 22:
                        _context.prev = 22;
                        _context.t0 = _context['catch'](0);


                        // Something went wrong and we don't know the module's latest version.
                        // Use an unversioned path, so that maybe the site might continue to work.
                        window.console.error('uig-frontend-version-util failed, couldn\'t find the content ' + ('root for ' + modulePath + '. Using unversioned url. Error was: ' + _context.t0));

                        return _context.abrupt('return', '/' + modulePath);

                    case 26:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[0, 22]]);
    }));

    return function getUrlRoot(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var _uigCurrentEnvironmentUtil = require('@sfly/uig-current-environment-util');

var _uigCdnLibraries = require('@sfly/uig-cdn-libraries');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint import/prefer-default-export:0 */

function moduleCurrentVersionUrl(modulePath, env, options) {
    var root = 'https://api2.shutterfly.com/frontendci';

    if (options && options.enablePreProdService && (0, _uigCurrentEnvironmentUtil.getCurrentEnv)() !== 'production') {
        root = 'https://frontend-ci.stage.shutterfly.com/api';
    }

    return root + ('/app/' + modulePath + '/env/' + env + '/current-version');
}

//# sourceMappingURL=index.js.map